import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import isMobile from "is-mobile";
import React, { useState } from "react";
import {
  Tooltip,
  Button,
  Classes,
  Checkbox,
  Menu,
  MenuItem,
  Popover,
  Position
} from "@blueprintjs/core";
import classNames from "classnames";
import DemoNav from "./DemoNav";
import "./style.css";
import { DataTable } from "@teselagen/ui";
import {
  HashRouter as Router,
  Route,
  Redirect,
  withRouter
} from "react-router-dom";
const DemoPage = ({
  demos,
  showComponentList,
  SideBarComponent,
  rightHeaderButtons
}) => {
  const [isOpen, setIsOpen] = useState(() => {
    const hash = window.location.hash;
    const search = window.location.search;
    let hideProjects = false;
    if (hash && hash.includes("?")) {
      const urlParams = new URLSearchParams(hash.split("?")[1]);
      hideProjects = urlParams.get("hideProjects") === "true";
    }
    if (!hideProjects && search) {
      const urlParams = new URLSearchParams(search);
      hideProjects = urlParams.get("hideProjects") === "true";
    }
    if (hideProjects) return false;
    const saved = localStorage.getItem("demoNavOpen");
    if (saved !== null) {
      return saved === "true";
    }
    return showComponentList;
  });
  const handleSetIsOpen = (value) => {
    setIsOpen(value);
    localStorage.setItem("demoNavOpen", value);
  };
  const [darkTheme, setDarkTheme] = useState(
    localStorage.getItem("darkTheme") === "true"
  );
  const [suppressReload, setSuppressReload] = useState(
    localStorage.getItem("suppressReload") === "true"
  );
  const [registryHost, setRegistryHost] = useState("/registry/");
  React.useEffect(() => {
    fetch("/api/config").then((res) => res.json()).then((data) => {
      if (data && data.registry_host) {
        setRegistryHost(data.registry_host);
      }
    }).catch((err) => {
      console.warn(
        "DemoPage: Failed to fetch registry config, using default",
        err
      );
    });
  }, []);
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      const key = e.key ? e.key.toLowerCase() : "";
      if (e.altKey && key === "p" || e.key === "F1") {
        e.preventDefault();
        e.stopPropagation();
        handleSetIsOpen(!isOpen);
      } else if (e.altKey && (key === "k" || e.code === "KeyK")) {
        e.preventDefault();
        e.stopPropagation();
        if (!isOpen) {
          handleSetIsOpen(true);
        }
        const focusSearch = () => {
          const input = document.querySelector(
            '[data-testid="search-input"] input, [data-testid="search-input"], #table-search-input, .ve-file-explorer-search input, input[placeholder*="Search by name/desc/DNA"], input[placeholder="Search..."]'
          );
          if (input) {
            input.focus();
            if (input.select) input.select();
            return true;
          }
          return false;
        };
        if (!focusSearch()) {
          [20, 60, 120, 250, 400].forEach((ms) => setTimeout(focusSearch, ms));
        }
      } else if (e.altKey && (key === "n" || e.code === "KeyN")) {
        e.preventDefault();
        e.stopPropagation();
        if (!isOpen) {
          handleSetIsOpen(true);
          [20, 60, 120, 250, 400].forEach(
            (ms) => setTimeout(() => {
              window.dispatchEvent(new CustomEvent("open-new-item-dialog"));
            }, ms)
          );
        } else {
          window.dispatchEvent(new CustomEvent("open-new-item-dialog"));
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [isOpen]);
  document.body.classList[darkTheme ? "add" : "remove"](Classes.DARK);
  return /* @__PURE__ */ jsx(Router, { children: /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: isMobile() ? "inherit" : "flex",
        maxWidth: "100%",
        minWidth: 0,
        width: "100%",
        height: "100%",
        minHeight: 0
      },
      children: [
        /* @__PURE__ */ jsx(
          DemoNav,
          {
            setIsOpen: handleSetIsOpen,
            isOpen,
            demos,
            SideBarComponent
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
              minWidth: 0,
              width: "100%",
              height: "100%",
              minHeight: 0
            },
            children: [
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: "demo-header",
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 20px",
                    height: 50,
                    minHeight: 50,
                    boxSizing: "border-box",
                    flexShrink: 0
                  },
                  children: [
                    /* @__PURE__ */ jsx("div", { style: { display: "flex", alignItems: "center", flexShrink: 0 }, children: !isOpen && /* @__PURE__ */ jsx(
                      Button,
                      {
                        onClick: () => {
                          handleSetIsOpen(true);
                        },
                        text: "Show Project Files",
                        style: { height: "fit-content", marginRight: 10 },
                        minimal: true,
                        intent: "primary",
                        icon: "chevron-right"
                      }
                    ) }),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        className: "ove-filename-display",
                        style: {
                          fontSize: 16,
                          flex: 1,
                          textAlign: "center",
                          padding: "0 10px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }
                      }
                    ),
                    /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", flexShrink: 0 }, children: [
                      /* @__PURE__ */ jsx(Tooltip, { content: "Copy URL to clipboard", children: /* @__PURE__ */ jsx(
                        Button,
                        {
                          icon: "share",
                          className: classNames(Classes.MINIMAL),
                          onClick: () => {
                            navigator.clipboard.writeText(window.location.href);
                            window.toastr?.success("URL copied to clipboard!");
                          }
                        }
                      ) }, "share"),
                      /* @__PURE__ */ jsx(
                        Popover,
                        {
                          position: Position.BOTTOM,
                          content: /* @__PURE__ */ jsxs(Menu, { children: [
                            /* @__PURE__ */ jsx(
                              MenuItem,
                              {
                                text: "Registry",
                                icon: "database",
                                onClick: () => {
                                  window.open(registryHost, "_blank");
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              MenuItem,
                              {
                                text: "Shipping",
                                icon: "document-share",
                                onClick: () => {
                                  document.cookie = "shipping_password=plasmid; path=/";
                                  window.open("/make_labels", "_blank");
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              MenuItem,
                              {
                                text: "Flow Analyzer",
                                icon: "send-to-graph",
                                onClick: () => {
                                  window.open("/flow_analyzer", "_blank");
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx(
                              MenuItem,
                              {
                                text: "Risk Reduction Tree",
                                icon: "diagram-tree",
                                onClick: () => {
                                  window.open("/rrt/", "_blank");
                                }
                              }
                            )
                          ] }),
                          children: /* @__PURE__ */ jsx(
                            Button,
                            {
                              text: "More Apps",
                              rightIcon: "caret-down",
                              className: classNames(Classes.MINIMAL)
                            }
                          )
                        }
                      ),
                      rightHeaderButtons,
                      window.location.hostname !== "main.delvetx.com" && /* @__PURE__ */ jsx(
                        Checkbox,
                        {
                          checked: suppressReload,
                          label: "No Reload",
                          style: { marginBottom: 0, marginLeft: 10, marginRight: 10 },
                          onChange: (e) => {
                            const val = e.target.checked;
                            setSuppressReload(val);
                            localStorage.setItem("suppressReload", val);
                          }
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        Tooltip,
                        {
                          content: darkTheme ? "Light Theme" : "Dark Theme",
                          children: /* @__PURE__ */ jsx(
                            Button,
                            {
                              icon: darkTheme ? "flash" : "moon",
                              className: classNames(Classes.MINIMAL),
                              onClick: darkTheme ? () => {
                                setDarkTheme(false);
                                localStorage.setItem("darkTheme", false);
                              } : () => {
                                setDarkTheme(true);
                                localStorage.setItem("darkTheme", true);
                              }
                            }
                          )
                        },
                        "theme"
                      ),
                      /* @__PURE__ */ jsx(
                        "span",
                        {
                          style: {
                            fontSize: 10,
                            opacity: 0.4,
                            marginLeft: 8,
                            whiteSpace: "nowrap",
                            fontFamily: "monospace"
                          },
                          children: window.__OVE_VERSION__ || ""
                        }
                      )
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ jsx(
                Route,
                {
                  exact: true,
                  path: "/",
                  render: () => /* @__PURE__ */ jsx(Redirect, { to: Object.keys(demos)[0] })
                }
              ),
              Object.keys(demos).map(function(key, index) {
                const demo = demos[key];
                return /* @__PURE__ */ jsxs(React.Fragment, { children: [
                  /* @__PURE__ */ jsx(
                    Route,
                    {
                      exact: true,
                      path: `/${key}`,
                      render: (routeProps) => /* @__PURE__ */ jsx(DemoComponentWrapper, { ...demo, ...routeProps })
                    }
                  ),
                  Object.keys(demo.childLinks || []).map((childKey, index2) => {
                    const childDemo = demo.childLinks[childKey];
                    return /* @__PURE__ */ jsx(
                      Route,
                      {
                        exact: true,
                        path: `/${key}/${childKey}`,
                        render: (routeProps) => /* @__PURE__ */ jsx(DemoComponentWrapper, { ...childDemo, ...routeProps })
                      },
                      key + childKey + index + index2
                    );
                  })
                ] }, key);
              })
            ]
          }
        )
      ]
    }
  ) });
};
export default DemoPage;
const demoPropsSchema = [
  {
    displayName: "Name",
    path: "name",
    width: 200,
    render: (v) => /* @__PURE__ */ jsx("span", { style: { color: "#5bc0de" }, children: v })
  },
  {
    displayName: "Type",
    width: 200,
    path: "type",
    render: (v) => /* @__PURE__ */ jsx("span", { style: { color: "#ff758d" }, children: v })
  },
  {
    displayName: "Description",
    path: "description"
  }
];
const DemoComponentWrapper = withRouter(
  ({ demo: Demo, noDemoMargin, DemoComponent, props = [], history }) => {
    let component;
    if (DemoComponent) {
      component = /* @__PURE__ */ jsx(DemoComponent, {});
    } else {
      component = /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Demo, { history }),
        !!props.length && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            "h6",
            {
              style: {
                marginTop: 25,
                marginBottom: 15
              },
              children: "Properties"
            }
          ),
          /* @__PURE__ */ jsx(
            DataTable,
            {
              formName: "demoProps",
              entities: props,
              isSimple: true,
              schema: demoPropsSchema
            }
          )
        ] })
      ] });
    }
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "demo-area-container",
        style: {
          ...!noDemoMargin && {
            overflow: "auto",
            padding: 40,
            minWidth: 0
          },
          width: "100%",
          flex: "1 1 auto",
          minHeight: 0
        },
        children: component
      }
    );
  }
);
